module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-block-container"
  }, [(_vm.statusCardsFiltered.length < 3) ? _c('div', {
    staticStyle: {
      "width": "16%",
      "float": "left",
      "margin": "5px",
      "box-sizing": "border-box"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.statusCardsFiltered), function(card) {
    return _c('div', {
      staticClass: "table-block",
      class: {
        'table-block-small': _vm.statusCardsFiltered.length > 3
      }
    }, [_c('div', {
      key: card.colorClass,
      staticClass: "table-block-inner dashboardStatusCard",
      class: card.colorClass,
      on: {
        "click": function($event) {
          return _vm.filterSendBox(card.changePageValue)
        }
      }
    }, [_c('div', {
      staticClass: "table-block-amount"
    }, [_vm._v("\n        " + _vm._s(_vm.commonfunctions.parseFloatOrInt(parseFloat(card.amount))) + " €\n      ")]), _vm._v(" "), _c('div', {
      class: {
        'large-table-block-label': card.isLarge, 'table-block-label': !card.isLarge
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t(card.labelId)) + "\n      ")])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5965b028", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5965b028","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/dashboardComponents/StatusCardsList.vue
// module id = 1676
// module chunks = 2